import { TypeEquipement } from './typeEquipement.model';

export class Equipement {
    id: number;
    no_equipement: string;
    quantite: number;
    statut: string;
    type_equipement: TypeEquipement;

    public constructor(init?: Partial<Equipement>) {
      Object.assign(this, init);
    }
  }
